import { useMutation, useQueryClient } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import {
  CreateCommissionLedgerEntryRequest,
  EarningsLedgerEntry,
  HttpResponse,
} from "@/types";

// Appends a PAID or CLAWBACK ledger entry; the BE reconciles the staffer's
// year, so refetch the whole earnings payload instead of hand-patching.
export function useCreateAddCommissionLedgerEntry() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (request: CreateCommissionLedgerEntryRequest) => {
      const res = await guacHttpClient.post<
        EarningsLedgerEntry,
        HttpResponse<EarningsLedgerEntry>
      >("staffer-earnings", request);

      return res.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["staffer-earnings"] });
    },
  });
}
